module.exports = __webpack_public_path__ + "img/2.a457b1d3.jpg";